import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function usePageParam(defaultPage = 1) {
  const { page } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [pageState, setPageState] = useState(defaultPage);

  const currentPage = Number(page) || defaultPage;

  useEffect(() => {
    setPageState(currentPage);
  }, [currentPage]);

  const setPage = newPage => {
    if (newPage !== currentPage) {
      // Get base path by removing page number if present
      let basePath = location.pathname;
      
      // If path ends with /number, remove it
      if (/\/\d+$/.test(basePath)) {
        basePath = basePath.replace(/\/\d+$/, '');
      }
      
      navigate(`${basePath}/${newPage}`, { replace: false });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return [currentPage, setPage];
}
